import React, { Component } from 'react';

import { Col, Row, Image } from 'react-bootstrap'

import logo from '../../../../img/logo-dark.png'
import i18n from "../../../i18n";

const titleStyle = {
    padding: "15px",
    display: "flex",
    alignItems: "center",
}

const h1style={
    fontWeight: "bold",
    fontSize: "21px",
}

const reportIdStyle = {
    fontWeight: "bold",
    fontSize: "18px",
    padding: "15px",
    display: "flex",
    alignItems: "center",
}

const marginRemove = {
    marginLeft: "0px",
    marginRight: "0px",
    backgroundColor: "rgba(0, 0, 0, .03)"
}

const logoAndId = "col-lg-3 col-sm-12 col-12 border"

export default class Title extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Row style={marginRemove}>
                <Col className={logoAndId} style={titleStyle}>
                    <Image src={logo} alt="Fina logo" />
                </Col>
                <Col className="col-lg-6 col-sm-12 col-12 border" style={titleStyle}>
                    <h1 style={h1style}>{i18n.t("simple:simple_report")}</h1>
                </Col>
                <Col className={logoAndId} style={reportIdStyle}>
                    <Row>
                        <Col className="col-8">
                            {i18n.t("docInfo:report_id")}
                        </Col>
                        <Col className="col-4">
                            {this.props.reportId}
                        </Col>
                    </Row>
                </Col>
            </Row>
        );
    }
}